import { useIntl } from 'react-intl';
import type { FieldErrors, FieldValues, Path, UseFormRegister } from 'react-hook-form';
import FieldLabel from '@/shared/components/FieldLabel';
import FieldError from '@/shared/components/FieldError';
import { inputClass } from '@/shared/utils/styles';
import { hasFieldError, type ServerErrors } from '@/shared/utils/fieldErrors';
import { isValidName } from '../validation';

interface Props<T extends FieldValues> {
  register: UseFormRegister<T>;
  errors: FieldErrors;
  serverErrors: ServerErrors;
}

export default function NameField<T extends { name: string }>({
  register,
  errors,
  serverErrors,
}: Props<T>) {
  const intl = useIntl();

  return (
    <div>
      <FieldLabel htmlFor="name" labelId="auth.signUp.nameLabel" />
      <input
        id="name"
        type="text"
        autoComplete="name"
        className={inputClass(hasFieldError('name', errors, serverErrors))}
        placeholder={intl.formatMessage({ id: 'auth.signUp.namePlaceholder' })}
        {...register('name' as Path<T>, { required: true, validate: isValidName })}
      />
      <FieldError field="name" errors={errors} serverErrors={serverErrors}
        messages={{ required: 'auth.signUp.nameRequired', validate: 'auth.signUp.nameFullRequired' }} />
    </div>
  );
}
